<template>
  <div class="hpanel no-margins" :class="type === 'similar' ? 'panel-collapse' : ''">
    <template v-if="searchState">

      <simple-list-authors-results v-if="authors" :context="context" v-model="authors"
                                   :nbEstimateExperts="nbEstimateExperts"
                                   :nbAuthors="allAuthors.length"
                                   :listType="listType" :changeSort="changeSort" :nbSearchCompanies="nbSearchCompanies"
                                   :localExperts="localExperts" :resetFilters="resetFilters"/>
    </template>
    <template v-else>
      <template v-if="authors.length === 0">
        <div class="panel-body">
          <div class="text-center">
            <h2 class="m-b-xs" v-if="type === 'selected'">Empty list - seleted experts</h2>
            <h2 class="m-b-xs" v-else-if="type === 'similar'">Empty list – similar experts</h2>
            <div class="m">
              <i class="pe-7s-search fa-5x"></i>
            </div>
            <p class="small">

            </p>
            <router-link class="btn btn-info btn-sm" :to="{name: 'Search'}">Explore and fill list of experts</router-link>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import SimpleListAuthorsResults from './SimpleListAuthorsResults'
import Filters from './../filter/Filters'
import WithoutWatchers from '../Mixins/WithoutWatchers'

export default {
  components: {
    Filters,
    SimpleListAuthorsResults
  },
  props: ['allAuthors', 'type', 'context', 'nbEstimateExperts', 'searchState', 'listType',
    'searchType', 'nbSearchCompanies', 'followedSearches', 'localExperts'],
  name: 'SimpleListAuthors',
  mixins: [WithoutWatchers],
  data () {
    return {
      localAllAuthors: [],
      authors: [],
      sort: {
        col: 'score',
        order: 'desc'
      }
    }
  },
  watch: {
    'context.affiliationsSelected': function (val) {
      this.initAuthors()
    },
    'context.countriesSelected': function () {
      this.initAuthors()
    },
    'context.pubDateSelected': function () {
      this.initAuthors()
    },
    'context.expertSourceSelected': function () {
      this.initAuthors()
    },
    'context.newDocumentsSelected': function () {
      this.initAuthors()
    },
    allAuthors: function (val) {
      this.localAllAuthors = val
    },
    localAllAuthors: function (val) {
      if (val.length !== 0) {
        this.initAuthors()
      } else {
        this.authors = []
      }
    },
    followedSearches: function (val) {
      if (val.length !== 0 && this.authors.length !== 0) {
        this.authors.forEach((author, key) => {
          let followSearchId = this.getItemFollowed(author)

          if (followSearchId !== null || author.followSearchId !== null) {
            author.followSearchId = followSearchId
            this.$set(this.authors, key, author)
          }
        })
      }
    }
  },
  methods: {
    initAuthors: function () {
      let authors = Object.assign([], this.localAllAuthors)

      if (typeof this.searchType !== 'undefined' && this.searchType !== null && this.searchType.type === 'Name') {
        authors = this.filterByName(authors)
      }

      if (this.context.affiliationsSelected.length === 0 && this.context.countriesSelected.length === 0 &&
          this.context.pubDateSelected.length === 0 && this.context.expertSourceSelected.length === 0 &&
          this.context.newDocumentsSelected.length === 0) {
        this.context.filterSelected = null
      } else {
        if ((this.context.affiliationsSelected.length === 0 && this.context.filterSelected === 'affiliation') ||
            (this.context.countriesSelected.length === 0 && this.context.filterSelected === 'country') ||
            (this.context.pubDateSelected.length === 0 && this.context.filterSelected === 'pubDate') ||
            (this.context.expertSourceSelected.length === 0 && this.context.expertSourceSelected === 'expertSource') ||
            (this.context.newDocumentsSelected.length === 0 && this.context.filterSelected === 'newDocuments')) {
          this.context.filterSelected = null
          this.initFilters(authors)
        }

        if (this.context.filterSelected === null) {
          if (this.context.affiliationsSelected.length > 0) {
            this.context.filterSelected = 'affiliation'
          }
          if (this.context.countriesSelected.length > 0) {
            this.context.filterSelected = 'country'
          }
          if (this.context.pubDateSelected.length > 0) {
            this.context.filterSelected = 'pubDate'
          }
          if (this.context.expertSourceSelected.length > 0) {
            this.context.filterSelected = 'expertSource'
          }
          if (this.context.newDocumentsSelected.length > 0) {
            this.context.filterSelected = 'newDocuments'
          }
        }
      }
      authors = this.applyFilters(authors)

      if (authors.length === 0) {
        // this.resetFilters()
      }

      this.initFilters(authors)

      authors = this.applyFilters(authors)

      this.applySort(authors)

      if (authors.length !== 0) {
        let itemsToDisplay = authors.find((item) => {
          return item.display === true
        })
        this.context.hasItemsToDisplay = (typeof itemsToDisplay !== 'undefined')
      }

      this.authors = Object.assign([], authors)
    },
    resetFilters: function () {
      this.context.filterSelected = null
      this.context.affiliationsSelected = []
      this.context.countriesSelected = []
      this.context.pubDateSelected = []
      this.context.expertSourceSelected = []
      this.context.newDocumentsSelected = []
    },
    initFilters: function (authors) {
      let affiliationsFilter = []
      let countriesFilter = []
      let pubDateFilter = []
      let expertSourceFilter = []
      let newDocumentsFilter = [{name: false, nb: 0}, {name: true, nb: 0}]

      if (this.$user.isSe()) {
        expertSourceFilter.push({nb: 0, name: 'TECHNICAL EDISON'})
      } else if (this.$user.isBicWorld()) {
        expertSourceFilter.push({nb: 0, name: 'BICWORLD'})
      }

      authors.forEach((author) => {
        if (typeof author.affiliation !== 'undefined' && author.affiliation) {
          if (typeof affiliationsFilter[author.affiliation.organisationID] === 'undefined') {
            affiliationsFilter[author.affiliation.organisationID] = {
              nb: 1,
              name: author.affiliation.organisationName,
              id: author.affiliation.organisationID,
              country: author.affiliation.country
            }
          } else {
            ++affiliationsFilter[author.affiliation.organisationID].nb
          }

          let country = countriesFilter.find((element) => {
            return element.name === author.affiliation.country
          })

          if (typeof country === 'undefined') {
            countriesFilter.push({nb: 1, name: author.affiliation.country})
          } else {
            ++country.nb
          }
        }

        let years = []
        author.docs.map((document) => {
          if (document.title !== 'Primary Domain' && document.title !== 'Influence' && document.title !== 'Training' &&
                document.title !== 'Publications') {
            let date = new Date(document.pubDate).getFullYear()

            let year = years.find((element) => {
              return element.name === date
            })

            if (typeof year === 'undefined') {
              years.push({name: date})
            } else {
              ++year.nb
            }
          }

          let followedSearch = newDocumentsFilter.find((element) => {
            return Boolean(element.name) === document.newDocument
          })

          if (typeof followedSearch !== 'undefined') {
            ++followedSearch.nb
          }
        })

        years.forEach((yearTmp) => {
          let year = pubDateFilter.find((element) => {
            return element.name === yearTmp.name
          })

          if (typeof year === 'undefined') {
            pubDateFilter.push({nb: 1, name: yearTmp.name})
          } else {
            ++year.nb
          }
        })

        let expertSource = expertSourceFilter.find((element) => {
          return (element.name === author.expertSource ||
              (author.expertSource === '' && element.name === null))
        })

        if (typeof expertSource === 'undefined') {
          expertSourceFilter.push({nb: 1, name: author.expertSource})
        } else {
          ++expertSource.nb
        }

        author.followSearchId = this.getItemFollowed(author)
      })

      affiliationsFilter.sort((affiliation1, affiliation2) => {
        return affiliation2.nb - affiliation1.nb
      })

      countriesFilter.sort((country1, country2) => {
        return country2.nb - country1.nb
      })

      pubDateFilter.sort((date1, date2) => {
        return parseInt(date2.name) - parseInt(date1.name)
      })

      if (this.context.filterSelected !== 'affiliation' || this.context.affiliationsFilter.length === 0) {
        this.context.affiliationsFilter = affiliationsFilter
      }
      if (this.context.filterSelected !== 'country' || this.context.countriesFilter.length === 0) {
        this.context.countriesFilter = countriesFilter
      }
      if (this.context.filterSelected !== 'pubDate' || this.context.pubDateFilter.length === 0) {
        this.context.pubDateFilter = pubDateFilter
      }
      if (this.context.filterSelected !== 'expertSource' || this.context.expertSourceFilter.length === 0) {
        this.context.expertSourceFilter = expertSourceFilter
      }
      if (this.context.filterSelected !== 'newDocuments' || this.context.newDocumentsFilter.length === 0) {
        this.context.newDocumentsFilter = newDocumentsFilter
      }

      if (this.context.filterSelected === null) {
        this.context.affiliationsFilter = affiliationsFilter
        this.context.countriesFilter = countriesFilter
        this.context.pubDateFilter = pubDateFilter
        this.context.expertSourceFilter = expertSourceFilter
        this.context.newDocumentsFilter = newDocumentsFilter
      }
      this.$emit('updatePubDate', this.context.pubDateFilter)
      this.$emit('updateCountries', {'countries': this.context.countriesFilter, 'companies': this.context.affiliationsFilter})
    },
    applyFilters: function (authors) {
      if (this.context.filterSelected !== null) {
        if (this.context.affiliationsSelected.length > 0 || this.context.countriesSelected.length > 0 ||
            this.context.pubDateSelected.length > 0 || this.context.expertSourceSelected.length > 0 ||
            this.context.newDocumentsSelected.length > 0) {
          authors = authors.filter((author) => {
            let authorFilterByAffiliation = true
            let authorFilterByCountry = true
            let authorFilterByPubDate = true
            let authorFilterByExpertSource = true
            let authorFilterByNewDocuments = true

            if (typeof author.affiliation !== 'undefined') {
              this.context.affiliationsSelected.map((affiliation) => {
                if (author.affiliation.organisationID === affiliation.id) {
                  authorFilterByAffiliation = false
                }
              })

              this.context.countriesSelected.map((country) => {
                if (author.affiliation.country === country.name) {
                  authorFilterByCountry = false
                }
              })

              this.context.expertSourceSelected.map((expertSource) => {
                if (author.expertSource === expertSource.name) {
                  authorFilterByExpertSource = false
                }
              })
            }

            let yearFound = false
            author.docs.map((document) => {
              let date = new Date(document.pubDate)
              this.context.pubDateSelected.map((year) => {
                if (date.getFullYear() === year.name && document.title !== 'Primary Domain' && document.title !== 'Influence' && document.title !== 'Training' &&
                    document.title !== 'Publications') {
                  yearFound = true
                }
              })
              if (yearFound === true) {
                authorFilterByPubDate = false
              }

              this.context.newDocumentsSelected.map((newDocument) => {
                if (newDocument.name === document.newDocument) {
                  authorFilterByNewDocuments = false
                }
              })
            })

            let authorFilter = true
            if (authorFilterByAffiliation === false || authorFilterByCountry === false ||
                authorFilterByPubDate === false || authorFilterByExpertSource === false ||
                authorFilterByNewDocuments === false) {
              authorFilter = false
              if (this.context.affiliationsSelected.length > 0 && authorFilter === false) {
                authorFilter = authorFilterByAffiliation
              }
              if (this.context.countriesSelected.length > 0 && authorFilter === false) {
                authorFilter = authorFilterByCountry
              }
              if (this.context.pubDateSelected.length > 0 && authorFilter === false) {
                authorFilter = authorFilterByPubDate
              }
              if (this.context.expertSourceSelected.length > 0 && authorFilter === false) {
                authorFilter = authorFilterByExpertSource
              }
              if (this.context.newDocumentsSelected.length > 0 && authorFilter === false) {
                authorFilter = authorFilterByNewDocuments
              }
            }
            return !authorFilter
          })
        }
      }
      return authors
    },
    applySort: function (authors) {
      switch (this.sort.col) {
        case 'expert':
          authors.sort((author1, author2) => {
            let author1Name = author1.lastName + ' ' + author1.firstName
            let author2Name = author2.lastName + ' ' + author2.firstName

            if (this.sort.order === 'desc') {
              return author2Name.toLowerCase() < author1Name.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return author1Name.toLowerCase() < author2Name.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'score':
          authors.sort((author1, author2) => {
            if (this.sort.order === 'desc') {
              return author2.score - author1.score
            } else if (this.sort.order === 'asc') {
              return author1.score - author2.score
            }
          })
          break
        case 'country':
          authors.sort((author1, author2) => {
            let country1 = typeof author1.affiliation.country === 'undefined' ? 'zzzzz' : author1.affiliation.country
            let country2 = typeof author2.affiliation.country === 'undefined' ? 'zzzzz' : author2.affiliation.country

            if (this.sort.order === 'desc') {
              return country2.toLowerCase() < country1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return country1.toLowerCase() < country2.toLowerCase() ? -1 : 1
            }
          })
          break
        case 'affiliation':
          authors.sort((author1, author2) => {
            let name1 = typeof author1.affiliation.organisationName === 'undefined'
              ? 'zzzzz' : author1.affiliation.organisationName
            let name2 = typeof author2.affiliation.organisationName === 'undefined'
              ? 'zzzzz' : author2.affiliation.organisationName

            if (this.sort.order === 'desc') {
              return name2.toLowerCase() < name1.toLowerCase() ? -1 : 1
            } else if (this.sort.order === 'asc') {
              return name1.toLowerCase() < name2.toLowerCase() ? -1 : 1
            }
          })
          break
      }
    },
    filterByName: function (authors) {
      authors = authors.filter((author) => {
        return this.isSimilarToExpertSearched(author)
      })
      return authors
    },
    isSimilarToExpertSearched: function (author) {
      let authorLastName = author.lastName.toLowerCase()
      let authorFirstName = author.firstName.toLowerCase()
      let querySearch = this.searchType.firstName + ' ' + this.searchType.lastName

      if (authorLastName && querySearch) {
        querySearch = querySearch.trim().toLowerCase()
        querySearch = querySearch.replace(/"/g, '')
        querySearch = querySearch.replace(/\s{2,}/, ' ')
        let query = querySearch.split(' ')

        if (authorFirstName) {
          if (authorLastName === query[query.length - 1] || (query[query.length - 1].length > 3 &&
              authorLastName.indexOf(query[query.length - 1]) !== -1)) {
            if (query.length === 1) {
              return true
            } // l'utilisateur entre qu'1 seul mot
            else if ((query[0].indexOf(authorFirstName) > -1) || (authorFirstName.length > 3 &&
                authorFirstName.indexOf(query[0]) !== -1) || (authorFirstName.length < 4 &&
                authorFirstName[0] === query[0][0]) || (query[0].length === 2 && authorFirstName > 3 &&
                authorFirstName[0] === query[0][0]) ||
                (query[0].replace(/[-\s]/g, '').indexOf(authorFirstName.replace(/[-\s]/g, '')) > -1)) {
              return true
            }
          }
        } else { // cas soap ne retourne pas first name
          if (authorLastName === query[query.length - 1] || (query[query.length - 1].length > 3 &&
              authorLastName.indexOf(query[query.length - 1]) !== -1)) {
            return true
          }
        }
      }
      return false
    },
    changeSort: function (col) {
      this.sort.col = col
      this.sort.order = (this.sort.order === 'desc' ? 'asc' : 'desc')
      this.applySort(this.authors)
    },
    showHidePanelList: function (event) {
      event.preventDefault()
      let hpanel = $(this.$el).closest('div.hpanel')
      let icon = $(this.$el).find('i:first')
      let body = hpanel.find('div.panel-body:first')
      let footer = hpanel.find('div.panel-footer:first')

      body.slideToggle(300)
      footer.slideToggle(200)

      // Toggle icon from up to down
      icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
      hpanel.toggleClass('').toggleClass('panel-collapse')

      setTimeout(function () {
        hpanel.resize()
        hpanel.find('[id^=map-]').resize()
      }, 50)
    },
    getItemFollowed (author) {
      let query = (author.firstName) ? ('name:"' + author.firstName.replace(/\s/g, ' ').replace(/\./g, ' ').trim() + ' ' + author.lastName.trim() + '"').toLowerCase()
        : ('name:"' + author.lastName.trim() + '"').toLowerCase()

      let followSearchId = null

      this.followedSearches.forEach((search) => {
        if (search.search_terms.term === query) {
          followSearchId = search.id
        }
      })
      return followSearchId
    }
  },
  beforeMount () {
    if (typeof this.$route.query.filters !== 'undefined') {
      let queryFilters = JSON.parse(this.$route.query.filters)

      if (typeof queryFilters.newDocs !== 'undefined') {
        if (queryFilters.newDocs === 'new') {
          this.$withoutWatchers(() => {
            this.context.newDocumentsSelected = [{name: true, nb: 0}]
            this.context.filterSelected = 'newDocuments'
          })
        }
      }
    }

    this.localAllAuthors = this.allAuthors
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAuthors/SimpleListAuthors.vue